<form-layout
    [showSave]="canSave"
    (onSave)="onSaveClick()"
    (onBack)="onBackClick()"
    (onNext)="onSaveAndNextClick()">

    <form [formGroup]="reviewForm">
        <div class="fields-wrapper">
            <section-info [overrideTitle]="'review.detail.title' | translate" [attr.aria-label]="'review.detail.title' | translate"></section-info>

            <kendo-formfield class="bewertung">
                <kendo-label class="form-label" [for]="bewertung" text="{{'review.bewertung' | translate}} *" [infotooltip]="'review.bewertung'"></kendo-label>
                <kendo-combobox formControlName="bewertung" [valuePrimitive]="true" #bewertung [allowCustom]="false" 
                [data]="bewertungList"
                [valueField]="'Value'"
                [appinfotext]="'review.bewertung'"
                [textField]="'Description'"
                kendoDropDownFilter
                >
                </kendo-combobox>
            </kendo-formfield>

            <kendo-formfield class="textarea">
                <kendo-label
                class="form-label"
                [for]="inhaltlicheZusammenfassung"
                text="{{'review.inhaltlicheZusammenfassung' | translate}} *" 
                [infotooltip]="'review.inhaltlicheZusammenfassung'"></kendo-label>
                <ckeditor #inhaltlicheZusammenfassung 
                formControlName="inhaltlicheZusammenfassung" 
                [editor]="Editor" 
                (ready)="initCKEditor($event, 'word-count-inhaltlicheZusammenfassung')" 
                data="" [config]="editorConfig" 
                [appinfotext]="'review.inhaltlicheZusammenfassung'">             
                </ckeditor>            
                <div id="word-count-inhaltlicheZusammenfassung"></div>
            </kendo-formfield>

            <kendo-formfield class="textarea">
                <kendo-label
                class="form-label"
                [for]="staerkenSchwaechenAnalyse"
                text="{{'review.staerkenSchwaechenAnalyse' | translate}} *"
                [infotooltip]="'review.staerkenSchwaechenAnalyse'"></kendo-label>
                <ckeditor #staerkenSchwaechenAnalyse 
                formControlName="staerkenSchwaechenAnalyse" 
                [editor]="Editor" 
                (ready)="initCKEditor($event, 'word-count-staerkenSchwaechenAnalyse')" 
                data="" [config]="editorConfig" 
                [appinfotext]="'review.staerkenSchwaechenAnalyse'">             
                </ckeditor>            
                <div id="word-count-staerkenSchwaechenAnalyse"></div>
            </kendo-formfield>

            <kendo-formfield class="textarea">
                <kendo-label 
                class="form-label"
                [for]="ergebnis"
                text="{{'review.ergebnis' | translate}} *"
                [infotooltip]="'review.ergebnis'"></kendo-label>
                <ckeditor #ergebnis 
                formControlName="ergebnis" 
                [editor]="Editor" 
                (ready)="initCKEditor($event, 'word-count-ergebnis')" 
                data="" [config]="editorConfig"
                [appinfotext]="'review.ergebnis'">             
                </ckeditor>            
                <div id="word-count-ergebnis"></div>
            </kendo-formfield>
        </div>
    </form>
</form-layout>